'use client';
import { FlagshipAdapter } from './flagship-provider';
import { useOfferHandler } from '@wwe-portal/web/hooks/offer/use-offer-handler';
import { OFFER_SOURCE } from '@wwe-portal/web/utils/constants/offer';
import { sendFlagshipOfferButtonIsTappedEvent } from '@wwe-portal/web/libs/analytics/offer';
import { useStoreData } from '@wwe-portal/web/hooks/offer/use-store-data';
import { SyntheticEvent } from 'react';

export const FlagshipSection = () => {
  const { flagshipOffers } = useStoreData();
  const { onClick, onClickPrice } = useOfferHandler(OFFER_SOURCE.SHOP, {
    getOfferById: (id: string) =>
      flagshipOffers?.find((offer) => offer.OffersID === id),
  });
  const handleOfferClick = (
    offerId: string,
    e: SyntheticEvent<Element, Event>,
    context: {
      slideIndex: number;
      totalSlides: number;
    }
  ) => {
    onClickPrice(offerId, e as never);

    const offerData = flagshipOffers?.find(
      (offer) => offer.OffersID === offerId
    );
    // Analytics
    if (offerData) {
      sendFlagshipOfferButtonIsTappedEvent({
        offerData,
        ...context,
      });
    }
  };
  const flagshipDisabled = !flagshipOffers || flagshipOffers.length === 0;
  if (flagshipDisabled) return null;
  return (
    <div className="-mx-5 xl:mx-[-30px]">
      <FlagshipAdapter
        offers={flagshipOffers}
        onClick={onClick}
        onClickPrice={handleOfferClick}
      />
    </div>
  );
};
